import PropTypes from 'prop-types';
import React from 'react';
import {
    Row,
    Text,
    Value
} from './styled';

const StatisticsItem = ({
    text,
    value
}) => (
    <Row>
        <Text>{ text }</Text>
        <Value>{ value }</Value>
    </Row>
);

StatisticsItem.propTypes = {
    text: PropTypes.string,
    value: PropTypes.oneOfType([PropTypes.number, PropTypes.string])
};

export default StatisticsItem;
